import React from 'react';
import smallCouncils from '../../helpers/small-councils';
import styles from './small-councis.module.scss';
export default function SmallCouncilList({ onClick }) {
  const baseUrl = process.env.PUBLIC_URL || '';
  return (
    <div>
      {smallCouncils.map(({ name, icon }) => {
        return (
          <li
            key={name}
            role="button"
            onClick={onClick({ id: name })}
            className={styles.li}
          >
            <img src={baseUrl + icon} alt={name} />{' '}
            <span className={styles.councilName}>{name}</span>
          </li>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/small-council-list/small-council-list.js